// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kJ4k9","colMin":"styles_colMin__3EUBY"};